import aboutIcon1 from './Images/home-about-icon-1.svg'
import aboutIcon2 from './Images/home-about-icon-2.svg'
import aboutIcon3 from './Images/home-about-icon-3.svg'
import aboutIcon4 from './Images/home-about-icon-4.svg'

import product1 from './Images/product-1.webp'
import product2 from './Images/product-2.webp'
import product3 from './Images/product-3.webp'
import product4 from './Images/product-4.webp'
import product5 from './Images/product-5.webp'
import product6 from './Images/product-6.webp'

import industry1 from './Images/industry-1.svg'
import industry2 from './Images/industry-2.svg'
import industry3 from './Images/industry-3.svg'
import industry4 from './Images/industry-4.svg'
import industry5 from './Images/industry-5.svg'
import industry6 from './Images/industry-6.svg'

import client1 from './Images/client-1.png'
import client2 from './Images/client-2.png'
import client3 from './Images/client-3.png'
import client4 from './Images/client-4.png'
import client5 from './Images/client-5.png'
import client6 from './Images/client-6.png'
import client7 from './Images/client-7.png'
import client8 from './Images/client-8.png'
import client9 from './Images/client-9.png'
import client10 from './Images/client-10.png'
import client11 from './Images/client-11.png'

import missionIcon from './Images/mission.svg'
import visionIcon from './Images/vision.svg'

import value1 from './Images/value-1.webp'
import value2 from './Images/value-2.webp'
import value3 from './Images/value-3.webp'
import value4 from './Images/value-4.webp'
import value5 from './Images/value-5.webp'

import serviceIntro1 from './Images/service-intro-icon-1.svg'
import serviceIntro2 from './Images/service-intro-icon-2.svg'
import serviceIntro3 from './Images/service-intro-icon-3.svg'
import serviceIntro4 from './Images/service-intro-icon-4.svg'

import service1 from './Images/service-1.webp'
import service2 from './Images/service-2.webp'
import service3 from './Images/service-3.webp'
import service4 from './Images/service-4.webp'
import service5 from './Images/service-5.webp'
import service6 from './Images/service-6.webp'

import serviceIcon1 from './Images/service-icon-1.svg'
import serviceIcon2 from './Images/service-icon-2.svg'
import serviceIcon3 from './Images/service-icon-3.svg'
import serviceIcon4 from './Images/service-icon-4.svg'
import serviceIcon5 from './Images/service-icon-5.svg'
import serviceIcon6 from './Images/service-icon-6.svg'

import product1Bg from './Images/product-1-breadcrumb.webp'
import product2Bg from './Images/product-2-breadcrumb.webp'
import product3Bg from './Images/product-3-breadcrumb.webp'
import product4Bg from './Images/product-4-breadcrumb.webp'
import product5Bg from './Images/product-5-breadcrumb.webp'

import product1Big1 from './Images/products/product-1-big-1.webp'
import product1Big2 from './Images/products/product-1-big-2.webp'
import product1Big3 from './Images/products/product-1-big-3.webp'
import product1Big4 from './Images/products/product-1-big-4.webp'
import product1Big5 from './Images/products/product-1-big-5.webp'

import product1Small1 from './Images/products/product-1-small-1.webp'
import product1Small2 from './Images/products/product-1-small-2.webp'
import product1Small3 from './Images/products/product-1-small-3.webp'
import product1Small4 from './Images/products/product-1-small-4.webp'
import product1Small5 from './Images/products/product-1-small-5.webp'

import product2Big1 from './Images/products/pro-2-big-1.webp'
import product2Big2 from './Images/products/pro-2-big-2.webp'
import product2Big3 from './Images/products/pro-2-big-3.webp'
import product2Big4 from './Images/products/pro-2-big-4.webp'
import product2Big5 from './Images/products/pro-2-big-5.webp'

import product2Small1 from './Images/products/pro-2-small-1.webp'
import product2Small2 from './Images/products/pro-2-small-2.webp'
import product2Small3 from './Images/products/pro-2-small-3.webp'
import product2Small4 from './Images/products/pro-2-small-4.webp'
import product2Small5 from './Images/products/pro-2-small-5.webp'

import product3Big1 from './Images/products/pro-3-big-1.webp'
import product3Big2 from './Images/products/pro-3-big-2.webp'
import product3Big3 from './Images/products/pro-3-big-3.webp'
import product3Big4 from './Images/products/pro-3-big-4.webp'
import product3Big5 from './Images/products/pro-3-big-5.webp'

import product3Small1 from './Images/products/pro-3-small-1.webp'
import product3Small2 from './Images/products/pro-3-small-2.webp'
import product3Small3 from './Images/products/pro-3-small-3.webp'
import product3Small4 from './Images/products/pro-3-small-4.webp'
import product3Small5 from './Images/products/pro-3-small-5.webp'

import product4Big1 from './Images/products/pro-4-big-1.webp'
import product4Big2 from './Images/products/pro-4-big-2.webp'
import product4Big3 from './Images/products/pro-4-big-3.webp'
import product4Big4 from './Images/products/pro-4-big-4.webp'
import product4Big5 from './Images/products/pro-4-big-5.webp'

import product4Small1 from './Images/products/pro-4-small-1.webp'
import product4Small2 from './Images/products/pro-4-small-2.webp'
import product4Small3 from './Images/products/pro-4-small-3.webp'
import product4Small4 from './Images/products/pro-4-small-4.webp'
import product4Small5 from './Images/products/pro-4-small-5.webp'

import product5Big1 from './Images/products/pro-5-big-1.webp'
import product5Big2 from './Images/products/pro-5-big-2.webp'
import product5Big3 from './Images/products/pro-5-big-3.webp'
import product5Big4 from './Images/products/pro-5-big-4.webp'
import product5Big5 from './Images/products/pro-5-big-5.webp'

import product5Small1 from './Images/products/pro-5-small-1.webp'
import product5Small2 from './Images/products/pro-5-small-2.webp'
import product5Small3 from './Images/products/pro-5-small-3.webp'
import product5Small4 from './Images/products/pro-5-small-4.webp'
import product5Small5 from './Images/products/pro-5-small-5.webp'

import pro1Q1 from './Images/products/product-1-q-1.svg'
import pro1Q2 from './Images/products/product-1-q-2.svg'
import pro1Q3 from './Images/products/product-1-q-3.svg'
import pro1Q4 from './Images/products/product-1-q-4.svg'
import pro1Q5 from './Images/products/product-1-q-5.svg'
import pro1Q6 from './Images/products/product-1-q-6.svg'

import pro2Q1 from './Images/products/product-1-q-1.svg'
import pro2Q2 from './Images/products/product-1-q-2.svg'
import pro2Q3 from './Images/products/product-1-q-5.svg'
import pro2Q4 from './Images/products/product-1-q-3.svg'
import pro2Q5 from './Images/products/product-1-q-6.svg'
import pro2Q6 from './Images/products/pro-2-q-6.svg'

import pro1FeatureImg from './Images/products/product-1-feature-img.webp'
import pro2FeatureImg from './Images/products/product-2-feature-img.webp'
import pro3FeatureImg from './Images/products/product-3-feature-img.webp'
import pro4FeatureImg from './Images/products/product-4-feature-img.webp'
import pro5FeatureImg from './Images/products/product-5-feature-img.webp'

import pro1f1 from './Images/products/pro-1-f-1.svg'
import pro1f2 from './Images/products/pro-1-f-2.svg'
import pro1f3 from './Images/products/pro-1-f-3.svg'
import pro1f4 from './Images/products/pro-1-f-4.svg'

import pro2f1 from './Images/products/pro-2-f-1.svg'
import pro2f2 from './Images/products/pro-2-f-2.svg'
import pro2f3 from './Images/products/pro-2-f-3.svg'
import pro2f4 from './Images/products/pro-2-f-4.svg'

import customiseIcon1 from './Images/customise-icon-1.svg'
import customiseIcon2 from './Images/customise-icon-2.svg'
import customiseIcon3 from './Images/customise-icon-3.svg'
import customiseIcon4 from './Images/customise-icon-4.svg'
import customiseIcon5 from './Images/customise-icon-5.svg'
import customiseIcon6 from './Images/customise-icon-6.svg'

import certificate1 from './Images/certficate-1.webp'
import certificate2 from './Images/certificate-2.webp'

import advancedManufacturing from './Images/advanced-manufacturing.svg'
import qualityAssured from './Images/home-about-icon-1.svg'
import customSolutions from './Images/custom-solutions.svg'
import timelyDelivery from './Images/timely-delivery.svg'

export const certificates=[
  {
    img:certificate1
  },
  {
    img:certificate2
  }
]

export const aboutPoints=[
    {
        icon:aboutIcon1,
        title:"Quality Assured",
        desc:"Strict quality control for maximum durability."
    },
    {
        icon:aboutIcon2,
        title:"Custom Solutions",
        desc:"Tailor-made packaging for your specific needs."
    },
    {
        icon:aboutIcon3,
        title:"Timely Delivery",
        desc:"Safe, secure, and always on schedule."
    },
    {
        icon:aboutIcon4,
        title:"Experienced Team",
        desc:"Industry experts with years of deep expertise."
    }
]

export const additionalProduct=[
   {
      slug:"customised-packaging",
      img:product6,
      title:"Customised Packaging",
      desc:"Tailor made wooden packaging solutions to match your export requirements",
   }
]

export const additionalProductGandhidham=[
  {
    slug:"customised-packaging-solution-in-gandhidham",
    img:product6,
    title:"Customised Packaging",
    desc:"Tailor made wooden packaging solutions to match your export requirements",
    faqHeading:"Frequently Asked Questions About Customised Packaging Solution in Gandhidham",
    faqs:[
      {
        question:"What is customised packaging?",
        answer:"Customised packaging is designed according to the specific size, weight, shape, handling and transportation requirements of a product."
      },
       {
        question:"Can you manufacture packaging according to our product dimensions?",
        answer:"Yes. We manufacture custom packaging according to your required length, width, height and product specifications."
      },
       {
        question:"What materials can be used for customised packaging?",
        answer:"Depending on the application, we can use suitable timber, plywood and reinforcement materials to provide the required strength and protection."
      },
       {
        question:"Can customised packaging be used for export?",
        answer:"Yes. Custom export packaging in Gandhidham can be manufactured with suitable heat treatment where ISPM-15 requirements apply."
      },
       {
        question:"Can you design packaging for heavy machinery?",
        answer:"Yes. Heavy-duty customised packaging can be designed with reinforced construction, suitable materials and internal supports for machinery and industrial equipment."
      },
       {
        question:"Can internal supports be added to customised packaging?",
        answer:"Yes. Internal supports, bracing and other protective elements can be incorporated according to the product and transportation requirements."
      },
       {
        question:"Do you provide customised pallets, crates and boxes?",
        answer:"Yes. We can customize wooden pallets, crates, boxes and other packaging formats based on your specific application."
      },
       {
        question:"How can I request a customised packaging solution?",
        answer:"You can share your product dimensions, weight, quantity and packaging requirements with our team. We will assess the requirements and suggest a suitable packaging solution."
      }
    ]
  }
]

export const products=[
    {
        metaTitle:"Euro Pallet Manufacturer in India | Gurukrupa Wood Pvt. Ltd.",
        metaDesc:"High-quality Euro pallets for export, warehousing & industrial logistics. Durable, strong & custom-size pallet solutions.",
        slug:"euro-pallets",
        img:product1,
        title:"Euro Pallets",
        desc:"Durable export-grade euro pallets designed for safe storage and transportation.",
        breadcrumbImg : product1Bg,
        introDesc:"Our Euro pallets are manufactured as per international quality standards (EPAL/ISPM-15 compliant), ensuring maximum strength, durability, and safety for both export and domestic shipments. Designed to facilitate seamless cross-border trade, these pallets meet rigorous phytosanitary requirements, ensuring your cargo moves through global supply chains without delays or compliance issues.",
        brochureLink:"/gurukrupa-brochure.pdf",
        images:[
    {
      big: product1Big1,
      small: product1Small1,
    },
    {
      big: product1Big2,
      small: product1Small2,
    },
    {
      big: product1Big3,
      small:product1Small3,
    },
    {
      big: product1Big4,
      small:product1Small4,
    },
     {
      big: product1Big5,
      small: product1Small5,
    },
  ],
  qualities:[
    {
      icon:pro1Q1,
      title: "ISPM-15 Heat Treated",
    },
    {
      icon: pro1Q2,
      title: "High Load Capacity",
    },
    {
      icon: pro1Q3,
      title: "EPAL Standard Quality",
    },
    {
      icon: pro1Q4,
      title: "Strong & Durable",
    },
    {
      icon: pro1Q5,
      title: "Moisture Resistant",
    },
    {
      icon: pro1Q6,
      title: "100% Ready for Export",
    },
  ],
  featureImage:pro1FeatureImg,
  features:[
    {
      icon:pro1f1,
      title: "Premium Quality Wood",
      desc: "Made from high-quality, seasoned timber for maximum strength.",
    },

    {
      icon: pro1f2,
      title: "Heat Treated (ISPM-15)",
      desc: "Compliant with ISPM-15 standards for safe global shipping.",
    },

    {
      icon: pro1f3,
      title: "High Load Capacity",
      desc: "Designed to handle heavy loads with excellent stability and durability.",
    },

    {
      icon: pro1f4,
      title: "Cost Effective",
      desc: "Long-lasting and reusable pallets for better ROI.",
    },
  ],
  ctaTitle:"Need a Custom Size or Design?",
  ctaDesc:"We provide tailor-made Euro pallets to match your exact requirements. Get in touch with our team today!",
  faqs:[
    {
        question:"Are your Euro pallets ISPM-15 compliant?",
        answer:"Yes, our Euro pallets can be manufactured with ISPM-15 heat treatment compliance for safe international shipping and export requirements."
    },
     {
        question:"What wood is used for Euro pallets?",
        answer:"We use high-quality pine wood, hardwood, or other suitable timber based on the required load capacity, application, and customer specifications."
    },
     {
        question:"Can you provide custom sizes?",
        answer:"Yes, we specialize in customized pallet solutions and can manufacture pallets in various sizes, designs, and load capacities as per your requirements."
    },
     {
        question:"What is the static load capacity?",
        answer:"The static load capacity depends on the pallet design and wood type. Our Euro pallets are designed to handle heavy industrial loads efficiently based on application needs."
    },
     {
        question:"Do you offer heat treatment?",
        answer:"Yes, we provide heat-treated wooden pallets as per export and international packaging standards, including ISPM-15 requirements."
    },
     {
        question:"Can we get a sample before bulk order?",
        answer:"Yes, sample pallets can be provided for quality evaluation and approval before proceeding with bulk production orders."
    },
     {
        question:"What is the lead time for orders?",
        answer:"Lead time varies depending on the order quantity and customization requirements. Standard orders are generally delivered within the committed production schedule."
    },
     {
        question:"Do you deliver across India and for export?",
        answer:"Yes, we supply and deliver wooden pallets across India and also support export packaging requirements for international shipments."
    }
  ]
    },
     {
        metaTitle:"Wooden Pallet Manufacturer in India | Gurukrupa Wood Pvt. Ltd.",
        metaDesc:"Heavy-duty wooden pallets designed for storage, export packaging & industrial transportation requirements.",
        slug:"wooden-pallets",
        img:product2,
        title:"Wooden Pallets",
        desc:"Strong and reliable wooden pallets for industrial handling and logistics applications.",
        breadcrumbImg : product2Bg,
        introDesc:"Gurukrupa Wood Pvt. Ltd. manufactures wooden pallets in Gujarat, India, using high-quality timber and advanced production techniques to ensure durability, strength, and long-lasting performance. Designed for industrial storage, logistics, warehouse handling, and export applications, these pallets provide reliable support for heavy loads and safe transportation.",
        brochureLink:"/gurukrupa-brochure.pdf",
        images:[
    {
      big: product2Big1,
      small: product2Small1,
    },
    {
      big: product2Big2,
      small: product2Small2,
    },
    {
      big: product2Big3,
      small:product2Small3,
    },
    {
      big: product2Big4,
      small:product2Small4,
    },
     {
      big: product2Big5,
      small: product2Small5,
    },
  ],
  qualities:[
    {
      icon:pro2Q1,
      title: "ISPM-15 Heat Treated",
    },
    {
      icon: pro2Q2,
      title: "High Load Capacity",
    },
    {
      icon: pro2Q3,
      title: "Moisture Resistant",
    },
    {
      icon: pro2Q4,
      title: "Strong & Durable",
    },
    {
      icon: pro2Q5,
      title: "100% Ready for Export",
    },
    {
      icon: pro2Q6,
      title: "Custom Sizes Available",
    },
  ],
  featureImage:pro2FeatureImg,
  features:[
    {
      icon:pro2f1,
      title: "Long Service Life",
      desc: "Designed for repeated industrial usage with reliable performance.",
    },

    {
      icon: pro2f2,
      title: "Safe Material Handling",
      desc: "Provides secure support during storage and transportation.",
    },

    {
      icon: pro2f3,
      title: "Heavy Duty Construction",
      desc: "Built using premium-quality wood for maximum strength and durability.",
    },

    {
      icon: pro2f4,
      title: "Cost Effective",
      desc: "Long-lasting and reusable pallets for better ROI.",
    },
  ],
  ctaTitle:"Need Custom Wooden Pallets?",
  ctaDesc:"We provide tailor-made Wooden pallets to match your exact requirements. Get in touch with our team today!",
  faqs:[
    {
        question:"What types of wooden pallets do you manufacture?",
        answer:"We manufacture a wide range of wooden pallets including two-way, four-way, heavy-duty, export-grade, and customized pallets for industrial applications."
    },
     {
        question:"Can wooden pallets be customized as per requirement?",
        answer:"Yes, we provide customized wooden pallets based on size, load capacity, wood type, and application requirements."
    },
     {
        question:"Are your wooden pallets suitable for export use?",
        answer:"Yes, we offer export-ready wooden pallets with ISPM-15 heat treatment for international shipping requirements."
    },
     {
        question:"What wood is used for manufacturing pallets?",
        answer:"We use high-quality pine wood, hardwood, and other suitable timber depending on the required strength and usage."
    },
     {
        question:"What industries use your wooden pallets?",
        answer:"Our wooden pallets are widely used in logistics, warehousing, manufacturing, engineering, chemical, pharmaceutical, and export industries."
    },
     {
        question:"What is the load capacity of your wooden pallets?",
        answer:"The load capacity depends on the pallet design and customer requirements. We manufacture pallets suitable for both medium and heavy-duty applications."
    },
     {
        question:"Do you provide bulk order supply and delivery?",
        answer:"Yes, we handle bulk manufacturing and supply orders with timely delivery across India and export support."
    },
     {
        question:"Can we request a sample before placing a large order?",
        answer:"Yes, sample pallets can be provided for approval and quality evaluation before proceeding with bulk production."
    }
  ]
    },
     {
        metaTitle:"Industrial Wooden Boxes | Gurukrupa Wood Pvt. Ltd.",
        metaDesc:"Durable wooden boxes for industrial packaging, export shipping & secure transportation of machinery and goods.",
        slug:"wooden-boxes",
        img:product3,
        title:"Wooden Boxes",
        desc:"Secure wooden boxes built for industrial packaging and safe material handling.",
        breadcrumbImg : product3Bg,
        introDesc:"Our wooden boxes are manufactured using premium-quality wood and advanced production methods to provide maximum protection during storage, shipping, and export operations. Designed for industrial packaging applications, these boxes offer excellent strength, durability, and load-bearing performance.",
        brochureLink:"/gurukrupa-brochure.pdf",
        images:[
    {
      big: product3Big1,
      small: product3Small1,
    },
    {
      big: product3Big2,
      small: product3Small2,
    },
    {
      big: product3Big3,
      small:product3Small3,
    },
    {
      big: product3Big4,
      small:product3Small4,
    },
     {
      big: product3Big5,
      small: product3Small5,
    },
  ],
  qualities:[
    {
      icon:pro2Q1,
      title: "ISPM-15 Heat Treated",
    },
    {
      icon: pro2Q2,
      title: "High Load Capacity",
    },
    {
      icon: pro2Q3,
      title: "Moisture Resistant",
    },
    {
      icon: pro2Q4,
      title: "Strong & Durable",
    },
    {
      icon: pro2Q5,
      title: "100% Ready for Export",
    },
    {
      icon: pro2Q6,
      title: "Custom Sizes Available",
    },
  ],
  featureImage:pro3FeatureImg,
  features:[
    {
      icon:pro1f1,
      title: "Premium Quality Wood",
      desc: "Made from high-quality, seasoned timber for maximum strength.",
    },

    {
      icon: pro1f2,
      title: "Heat Treated (ISPM-15)",
      desc: "Compliant with ISPM-15 standards for safe global shipping.",
    },

    {
      icon: pro1f3,
      title: "Heavy Duty Construction",
      desc: "Built using premium-quality wood for maximum strength and durability.",
    },

    {
      icon: pro1f4,
      title: "Cost Effective",
      desc: "Durable wooden boxes that provide protection and long-term value for industrial packaging.",
    },
  ],
  ctaTitle:"Need Custom Wooden Boxes?",
  ctaDesc:"We provide tailor-made Wooden boxes to match your exact requirements. Get in touch with our team today!",
  faqs:[
    {
        question:"Do you provide customized wooden boxes?",
        answer:"Yes, we manufacture wooden boxes in customized sizes, structures, and load capacities based on customer requirements."
    },
     {
        question:"Are your wooden boxes suitable for export packaging?",
        answer:"Yes, we provide export-grade wooden boxes with ISPM-15 heat treatment options for international shipping."
    },
     {
        question:"What type of products can be packed in wooden boxes?",
        answer:"Our wooden boxes are suitable for machinery, industrial equipment, engineering components, and heavy materials."
    },
     {
        question:"Do you offer heavy-duty wooden boxes?",
        answer:"Yes, we manufacture heavy-duty wooden boxes designed for industrial and high-load applications."
    },
     {
        question:"What wood is used for manufacturing wooden boxes?",
        answer:"We use high-quality timber and suitable wood materials depending on the packaging and load requirements."
    },
     {
        question:"Can internal supports and partitions be added?",
        answer:"Yes, customized internal supports, partitions, and reinforcements can be provided as per packaging needs."
    },
     {
        question:"Do you handle bulk orders?",
        answer:"Yes, we undertake bulk manufacturing and supply orders with timely delivery support."
    },
     {
        question:"Do you deliver across India and for exports?",
        answer:"Yes, we supply wooden boxes across India and also support export packaging requirements."
    }
  ]
    },
     {
        metaTitle:"Plywood Box Manufacturer in India | Gurukrupa Wood Pvt. Ltd.",
        metaDesc:"Premium plywood boxes for export packaging, industrial equipment handling & safe transportation applications.",
        slug:"plywood-boxes",
        img:product4,
        title:"Plywood Boxes",
        desc:"High-strength plywood boxes ideal for export and heavy-duty packaging solutions.",
        breadcrumbImg : product4Bg,
        introDesc:"Gurukrupa Wood Pvt. Ltd. manufactures Plywood Boxes in Gujarat, India, using high-quality plywood sheets and reinforced structural framing to provide superior strength, durability, and protection during transportation and storage. Designed for industrial and export applications, these boxes offer reliable packaging solutions for machinery, equipment, engineering components, and fragile materials.",
        brochureLink:"/gurukrupa-brochure.pdf",
        images:[
    {
      big: product4Big1,
      small: product4Small1,
    },
    {
      big: product4Big2,
      small: product4Small2,
    },
    {
      big: product4Big3,
      small:product4Small3,
    },
    {
      big: product4Big4,
      small:product4Small4,
    },
     {
      big: product4Big5,
      small: product4Small5,
    },
  ],
  qualities:[
    {
      icon:pro2Q1,
      title: "ISPM-15 Heat Treated",
    },
    {
      icon: pro2Q2,
      title: "High Load Capacity",
    },
    {
      icon: pro2Q3,
      title: "Moisture Resistant",
    },
    {
      icon: pro2Q4,
      title: "Strong & Durable",
    },
    {
      icon: pro2Q5,
      title: "100% Ready for Export",
    },
    {
      icon: pro2Q6,
      title: "Custom Sizes Available",
    },
  ],
  featureImage:pro4FeatureImg,
  features:[
    {
      icon:pro1f1,
      title: "Durable Structural Design",
      desc: "Manufactured with reinforced plywood construction for maximum strength and protection.",
    },

    {
      icon: pro1f2,
      title: "Lightweight Packaging",
      desc: "Offers strong load-bearing performance with reduced packaging weight.",
    },

    {
      icon: pro1f3,
      title: "Export-Ready Standards",
      desc: "Suitable for domestic and international shipping applications.",
    },

    {
      icon: pro1f4,
      title: "Versatile Industrial Applications",
      desc: "Ideal for machinery, engineering products, electronics, and industrial equipment.",
    },
  ],
  ctaTitle:"Need Custom Plywood Packaging Boxes?",
  ctaDesc:"We provide tailor-made Plywood boxes to match your exact requirements. Get in touch with our team today!",
  faqs:[
    {
        question:" What are plywood boxes used for?",
        answer:"Plywood boxes are widely used for industrial packaging, export shipments, machinery transportation, and secure storage applications."
    },
     {
        question:"Are your plywood boxes suitable for export packaging?",
        answer:"Yes, our plywood boxes are designed for export packaging and can be manufactured with ISPM-15 compliant treatment when required."
    },
     {
        question:"Can plywood boxes be customized?",
        answer:"Yes, we provide fully customized plywood boxes based on dimensions, load capacity, internal supports, and application requirements."
    },
     {
        question:"What materials are used in manufacturing plywood boxes?",
        answer:"We use premium-grade plywood sheets along with reinforced wooden framing for strength and durability."
    },
     {
        question:" Are lightweight plywood boxes available?",
        answer:"Yes, plywood boxes are comparatively lightweight while still offering excellent structural strength for industrial applications."
    },
     {
        question:" Can internal partitions and supports be added?",
        answer:"Yes, internal supports, cushioning, partitions, and reinforcements can be customized based on packaging requirements."
    },
     {
        question:"Do you handle bulk manufacturing orders?",
        answer:"Yes, we undertake bulk production orders with timely supply and delivery support."
    },
     {
        question:"Do you deliver across India and for export requirements?",
        answer:"Yes, we supply plywood boxes across India and also support export-oriented packaging solutions."
    }
  ]
    },
      {
        metaTitle:"Wooden Crates for Export Packaging | Gurukrupa Wood Pvt. Ltd.",
        metaDesc:"Heavy-duty wooden crates designed for machinery packaging, export cargo & industrial logistics applications.",
        slug:"wooden-crates",
        img:product5,
        title:"Wooden Crates",
        desc:"Durable wooden crates ideal for export and heavy-duty packaging solutions.",
        breadcrumbImg : product5Bg,
        introDesc:"Our wooden crates are manufactured using high-quality timber and reinforced structural construction to provide maximum protection for industrial equipment, machinery, and export cargo. Designed for heavy-duty applications, these crates ensure safe handling, secure transportation, and long-lasting durability across demanding logistics environments.",
        brochureLink:"/gurukrupa-brochure.pdf",
        images:[
    {
      big: product5Big1,
      small: product5Small1,
    },
    {
      big: product5Big2,
      small: product5Small2,
    },
    {
      big: product5Big3,
      small:product5Small3,
    },
    {
      big: product5Big4,
      small:product5Small4,
    },
     {
      big: product5Big5,
      small: product5Small5,
    },
  ],
  qualities:[
    {
      icon:pro2Q1,
      title: "ISPM-15 Heat Treated",
    },
    {
      icon: pro2Q2,
      title: "High Load Capacity",
    },
    {
      icon: pro2Q3,
      title: "Moisture Resistant",
    },
    {
      icon: pro2Q4,
      title: "Strong & Durable",
    },
    {
      icon: pro2Q5,
      title: "100% Ready for Export",
    },
    {
      icon: pro2Q6,
      title: "Custom Sizes Available",
    },
  ],
  featureImage:pro5FeatureImg,
  features:[
    {
      icon:pro1f1,
      title: "Durable Structural Design",
      desc: "Manufactured with reinforced plywood construction for maximum strength and protection.",
    },

    {
      icon: pro1f2,
      title: "Lightweight Packaging",
      desc: "Offers strong load-bearing performance with reduced packaging weight.",
    },

    {
      icon: pro1f3,
      title: "Export-Ready Standards",
      desc: "Suitable for domestic and international shipping applications.",
    },

    {
      icon: pro1f4,
      title: "Versatile Industrial Applications",
      desc: "Ideal for machinery, engineering products, electronics, and industrial equipment.",
    },
  ],
  ctaTitle:"Need Custom Wooden Crates?",
  ctaDesc:"We provide tailor-made Wooden Crates to match your exact requirements. Get in touch with our team today!",
  faqs:[
    {
        question:"What are wooden crates used for?",
        answer:"Wooden crates are used for packaging, storing, and transporting industrial machinery, equipment, and heavy cargo safely."
    },
     {
        question:"Can wooden crates be customized?",
        answer:"Yes, we provide customized wooden crates based on dimensions, weight capacity, and transportation requirements."
    },
     {
        question:"Are your wooden crates suitable for export packaging?",
        answer:"Yes, we manufacture export-ready wooden crates with ISPM-15 heat treatment options."
    },
     {
        question:"What wood is used for manufacturing wooden crates?",
        answer:"We use high-quality timber and suitable wood materials depending on load and application requirements."
    },
     {
        question:"Do you manufacture heavy-duty wooden crates?",
        answer:"Yes, we specialize in heavy-duty industrial wooden crates designed for large equipment and machinery transportation."
    },
     {
        question:"Are open-type and closed-type crates available?",
        answer:"Yes, both open and closed wooden crate designs are available based on packaging needs."
    },
     {
        question:"Can internal supports and reinforcements be added?",
        answer:"Yes, customized internal supports, partitions, and structural reinforcements can be provided."
    },
     {
        question:"Do you supply wooden crates across India and for export?",
        answer:"Yes, we supply wooden crates across India and support export packaging requirements globally."
    }
  ]
    }
]

export const GandhidhamProducts=[
{
  metaTitle:"Euro Pallets Manufacturer in Gandhidham | Gurukrupa Wood Pvt. Ltd.",
  metaDesc:"Gurukrupa Wood is a trusted Euro pallets manufacturer in Gandhidham, offering durable, export-ready pallets for industrial, logistics and packaging needs.",
  slug:"euro-pallets-manufacturer-in-gandhidham",
  img:product1,
  title:"Euro Pallets",
  breadcrumbHeading:"Euro Pallets Manufacturer in Gandhidham",
  desc:"Durable export-grade euro pallets designed for safe storage and transportation.",
  breadcrumbImg : product1Bg,
  introHeading:"Premium Euro Pallets from a Trusted Manufacturer in Gandhidham",
  introDesc:"Our Euro pallets support reliable handling, storage and transportation across industrial and export applications. As a trusted Euro pallets manufacturer in Gandhidham, we produce strong, durable pallets using quality timber and practical construction. Choose standard Euro pallet dimensions or custom Euro pallets in Gandhidham, designed to meet your specific logistics requirements.",
  brochureLink:"/gurukrupa-brochure.pdf",
  images:[
    {
      big: product1Big1,
      small: product1Small1,
    },
    {
      big: product1Big2,
      small: product1Small2,
    },
    {
      big: product1Big3,
      small:product1Small3,
    },
    {
      big: product1Big4,
      small:product1Small4,
    },
     {
      big: product1Big5,
      small: product1Small5,
    },
  ],
  qualities:[
    {
      icon:pro1Q1,
      title: "ISPM-15 Heat Treated",
    },
    {
      icon: pro1Q2,
      title: "High Load Capacity",
    },
    {
      icon: pro1Q3,
      title: "EPAL Standard Quality",
    },
    {
      icon: pro1Q4,
      title: "Strong & Durable",
    },
    {
      icon: pro1Q5,
      title: "Moisture Resistant",
    },
    {
      icon: pro1Q6,
      title: "100% Ready for Export",
    },
  ],
  featureImage:pro1FeatureImg,
  features:[
    {
      icon:pro1f1,
      title: "Premium Quality Wood",
      desc: "Made from high-quality, seasoned timber for maximum strength.",
    },

    {
      icon: pro1f2,
      title: "Heat Treated (ISPM-15)",
      desc: "Compliant with ISPM-15 standards for safe global shipping.",
    },

    {
      icon: pro1f3,
      title: "High Load Capacity",
      desc: "Designed to handle heavy loads with excellent stability and durability.",
    },

    {
      icon: pro1f4,
      title: "Cost Effective",
      desc: "Long-lasting and reusable pallets for better ROI.",
    },
  ],
  industriesHeading:"Precision Packaging for Every Industrial Application in Gandhidham",
  ctaTitle:"Need a Custom Euro Pallet Size or Design?",
  ctaDesc:"As an experienced Euro pallets manufacturer in Gandhidham, we help businesses choose practical pallet designs for industrial storage, domestic transportation and export packaging requirements.",
  faqsHeading:"Frequently Asked Questions About Euro Pallets in Gandhidham",
  faqs:[
    {
        question:"Are your Euro pallets suitable for export?",
        answer:"Yes. ISPM-15 heat-treated Euro pallets can be provided for export applications where compliant wooden packaging is required."
    },
     {
        question:"What wood is used for Euro pallets?",
        answer:"Euro pallets can be manufactured using suitable quality timber selected based on the required strength, durability and intended application."
    },
     {
        question:"Can you provide custom Euro pallet sizes?",
        answer:"Yes. We can manufacture custom wooden pallets in Gandhidham based on your required dimensions, load capacity and product handling needs."
    },
     {
        question:"What is the load capacity of a Euro pallet?",
        answer:"The load capacity depends on the pallet design, timber construction, dimensions and the way the load is distributed. We can recommend a suitable design based on your requirements."
    },
     {
        question:"Do you offer heat treatment?",
        answer:"Yes. Heat treatment can be provided for pallets requiring ISPM-15 compliance for export and international shipping."
    },
     {
        question:"Can we get a sample before bulk order?",
        answer:"Depending on the order requirements, a sample or prototype can be discussed before proceeding with larger production quantities."
    },
     {
        question:"What is the lead time for orders?",
        answer:"Lead times depend on the pallet quantity, design specifications and current production requirements. Contact us for an estimated delivery schedule."
    },
     {
        question:"Do you supply Euro pallets for export businesses?",
        answer:"Yes. We supply export wooden pallets in Gandhidham and can provide heat-treated solutions based on shipping and packaging requirements."
    }
  ],
  cta2Title:"Reliable Euro Pallet Manufacturing for Gandhidham Industries",
  cta2Desc:"Choose reliable Euro pallets in Gandhidham for quality wooden pallets designed around your storage, transportation and industrial packaging requirements."
  },
{
  metaTitle:"Wooden Pallets Manufacturer in Gandhidham | Gurukrupa Wood Pvt. Ltd.",
  metaDesc:"Gurukrupa Wood is a reliable wooden pallets manufacturer in Gandhidham, offering durable pallets for industrial, logistics, storage and export applications.",
  slug:"wooden-pallets-manufacturer-in-gandhidham",
  img:product2,
  title:"Wooden Pallets",
  breadcrumbHeading:"Wooden Pallets Manufacturer in Gandhidham",
  desc:"Strong and reliable wooden pallets for industrial handling and logistics applications.",
  breadcrumbImg : product2Bg,
  introHeading:"Premium Wooden Pallets from a Trusted Manufacturer in Gandhidham",
  introDesc:"Gurukrupa Wood Pvt. Ltd. is an experienced wooden pallets manufacturer in Gandhidham, producing durable pallets for industrial handling, storage, logistics and export operations. Using quality timber and practical manufacturing techniques, we provide strong, stable solutions for different load requirements, including custom wooden pallets in Gandhidham tailored to your dimensions and handling needs.",
  brochureLink:"/gurukrupa-brochure.pdf",
  images:[
    {
      big: product2Big1,
      small: product2Small1,
    },
    {
      big: product2Big2,
      small: product2Small2,
    },
    {
      big: product2Big3,
      small:product2Small3,
    },
    {
      big: product2Big4,
      small:product2Small4,
    },
     {
      big: product2Big5,
      small: product2Small5,
    },
  ],
  qualities:[
    {
      icon:pro2Q1,
      title: "ISPM-15 Heat Treated",
    },
    {
      icon: pro2Q2,
      title: "High Load Capacity",
    },
    {
      icon: pro2Q3,
      title: "Moisture Resistant",
    },
    {
      icon: pro2Q4,
      title: "Strong & Durable",
    },
    {
      icon: pro2Q5,
      title: "100% Ready for Export",
    },
    {
      icon: pro2Q6,
      title: "Custom Sizes Available",
    },
  ],
  featureImage:pro2FeatureImg,
  features:[
    {
      icon:pro2f1,
      title: "Long Service Life",
      desc: "Designed for repeated industrial usage with reliable performance.",
    },

    {
      icon: pro2f2,
      title: "Safe Material Handling",
      desc: "Provides secure support during storage and transportation.",
    },

    {
      icon: pro2f3,
      title: "Heavy Duty Construction",
      desc: "Built using premium-quality wood for maximum strength and durability.",
    },

    {
      icon: pro2f4,
      title: "Cost Effective",
      desc: "Long-lasting and reusable pallets for better ROI.",
    },
  ],
  industriesHeading:"Precision Packaging for Every Industrial Application in Gandhidham",
  ctaTitle:"Need a Custom Wooden Pallet Size or Design?",
  ctaDesc:"From standard Wooden pallets to specialised designs, we focus on providing reliable packaging that supports safe storage, efficient handling and transportation.",
  faqsHeading:"Frequently Asked Questions About Wooden Pallets in Gandhidham",
  faqs:[
    {
        question:"What types of wooden pallets do you manufacture?",
        answer:"We manufacture wooden pallets in different sizes and configurations for industrial handling, storage, warehousing, logistics and transportation applications."
    },
     {
        question:"Can wooden pallets be customized as per requirements?",
        answer:"Yes. We provide custom wooden pallets in Gandhidham based on your required dimensions, load capacity, product size and handling requirements."
    },
     {
        question:"Are your wooden pallets suitable for export use?",
        answer:"Yes. We can provide heat-treated wooden pallets suitable for export shipments where ISPM-15 compliance is required."
    },
     {
        question:"What wood is used for manufacturing wooden pallets?",
        answer:"We use suitable quality timber selected according to the required strength, durability and intended application of the pallet."
    },
     {
        question:"What is the load capacity of your wooden pallets?",
        answer:"Load capacity depends on the pallet dimensions, timber type, construction and load distribution. We can recommend a suitable pallet design based on your product requirements."
    },
     {
        question:"Do you provide heavy-duty wooden pallets?",
        answer:"Yes. Heavy-duty wooden pallets in Gandhidham can be manufactured for machinery, industrial equipment and other applications involving higher load requirements."
    },
     {
        question:"What industries use your wooden pallets?",
        answer:"Our wooden pallets are used across manufacturing, engineering, chemical, logistics, export and industrial equipment sectors for safe product handling and transportation."
    },
     {
        question:"Do you supply wooden pallets for bulk orders?",
        answer:"Yes. We can supply wooden pallets for bulk industrial and commercial requirements. Contact our team with your required size, quantity and specifications for a suitable quotation."
    }
  ],
  cta2Title:"Reliable Wooden Pallet Manufacturing for Gandhidham Industries",
  cta2Desc:"We are here to provide the best Wooden Pallets in Gandhidham tailored to your needs."
  },
{
  metaTitle:"Wooden Boxes Manufacturer in Gandhidham | Gurukrupa Wood Pvt. Ltd.",
  metaDesc:"Gurukrupa Wood is a trusted wooden boxes manufacturer in Gandhidham, offering strong, durable packaging boxes for industrial, logistics and export needs.",
  slug:"wooden-boxes-manufacturer-in-gandhidham",
  img:product3,
  title:"Wooden Boxes",
  breadcrumbHeading:"Wooden Boxes Manufacturer in Gandhidham",
  desc:"Secure Wooden Boxes built for industrial packaging and safe material handling.",
  breadcrumbImg : product3Bg,
  introHeading:"Premium Wooden Boxes from a Trusted Manufacturer in Gandhidham",
  introDesc:"Gurukrupa Wood Pvt. Ltd. is an experienced Wooden Boxes Manufacturer in Gandhidham, producing strong and reliable wooden boxes for industrial packaging. Using quality timber and practical construction, we protect machinery, components and goods during storage, handling and transportation. We also provide custom wooden boxes in Gandhidham based on product dimensions, weight and packaging requirements.",
  brochureLink:"/gurukrupa-brochure.pdf",
  images:[
    {
      big: product3Big1,
      small: product3Small1,
    },
    {
      big: product3Big2,
      small: product3Small2,
    },
    {
      big: product3Big3,
      small:product3Small3,
    },
    {
      big: product3Big4,
      small:product3Small4,
    },
     {
      big: product3Big5,
      small: product3Small5,
    },
  ],
  qualities:[
    {
      icon:pro2Q1,
      title: "ISPM-15 Heat Treated",
    },
    {
      icon: pro2Q2,
      title: "High Load Capacity",
    },
    {
      icon: pro2Q3,
      title: "Moisture Resistant",
    },
    {
      icon: pro2Q4,
      title: "Strong & Durable",
    },
    {
      icon: pro2Q5,
      title: "100% Ready for Export",
    },
    {
      icon: pro2Q6,
      title: "Custom Sizes Available",
    },
  ],
  featureImage:pro3FeatureImg,
  features:[
    {
      icon:pro1f1,
      title: "Premium Quality Wood",
      desc: "Made from high-quality, seasoned timber for maximum strength.",
    },

    {
      icon: pro1f2,
      title: "Heat Treated (ISPM-15)",
      desc: "Compliant with ISPM-15 standards for safe global shipping.",
    },

    {
      icon: pro1f3,
      title: "Heavy Duty Construction",
      desc: "Built using premium-quality wood for maximum strength and durability.",
    },

    {
      icon: pro1f4,
      title: "Cost Effective",
      desc: "Durable wooden boxes that provide protection and long-term value for industrial packaging.",
    },
  ],
  industriesHeading:"Precision Packaging for Every Industrial Application in Gandhidham",
  ctaTitle:"Need a Custom Wooden Boxes Size or Design?",
  ctaDesc:"We provide custom wooden boxes in Gandhidham designed according to your product size, weight and transportation requirements. Get in touch with our team today!",
  faqsHeading:"Frequently Asked Questions About Wooden Boxes in Gandhidham",
  faqs:[
    {
        question:"Do you provide customized wooden boxes?",
        answer:"Yes. We manufacture custom wooden boxes in Gandhidham based on product dimensions, weight, protection requirements and transportation conditions."
    },
     {
        question:"Are your wooden boxes suitable for export packaging?",
        answer:"Yes. Heat-treated wooden boxes can be provided for export applications where ISPM-15 requirements apply to wooden packaging materials."
    },
     {
        question:"What type of products can be packed in wooden boxes?",
        answer:"Wooden boxes can be used for machinery, industrial components, engineering products, equipment and other goods that require secure protection during transportation and storage."
    },
     {
        question:"Do you offer heavy-duty wooden boxes?",
        answer:"Yes. We manufacture heavy-duty wooden boxes for larger, heavier or sensitive industrial products that require additional structural support and protection."
    },
     {
        question:"What wood is used for manufacturing wooden boxes?",
        answer:"We use suitable quality timber selected according to the required strength, durability, box design and intended application."
    },
     {
        question:"Can wooden boxes be designed for specific product dimensions?",
        answer:"Yes. Wooden boxes can be manufactured according to your product dimensions to provide a suitable fit and minimise unnecessary movement during transportation."
    },
     {
        question:"Do you provide heat-treated wooden boxes?",
        answer:"Yes. Heat treatment can be provided for wooden boxes intended for export shipments where ISPM-15 compliant wooden packaging is required."
    },
     {
        question:"Can you supply wooden boxes for bulk industrial requirements?",
        answer:"Yes. We can manufacture and supply wooden boxes for bulk industrial, commercial and export packaging requirements based on the required size, quantity and specifications."
    }
  ],
  cta2Title:"Reliable Wooden Boxes Manufacturing for Gandhidham Industries",
  cta2Desc:"We are here to provide the best wooden boxes in gandhidham tailored to your needs."
  },
{
  metaTitle:"Plywood Boxes Manufacturer in Gandhidham | Gurukrupa Wood Pvt. Ltd.",
  metaDesc:"Gurukrupa Wood is a trusted plywood boxes manufacturer in Gandhidham, offering durable packaging boxes for industrial, machinery, logistics and export needs.",
  slug:"plywood-boxes-manufacturer-in-gandhidham",
  img:product4,
  title:"Plywood Boxes",
  breadcrumbHeading:"Plywood Boxes Manufacturer in Gandhidham",
  desc:"High strength plywood boxes ideal for export and heavy-duty packaging solutions.",
  breadcrumbImg : product4Bg,
  introHeading:"Premium Plywood Boxes from a Trusted Manufacturer in Gandhidham",
  introDesc:"Gurukrupa Wood Pvt. Ltd. is an experienced Plywood Boxes Manufacturer in Gandhidham, producing durable plywood boxes for industrial, engineering, machinery and export packaging. Using quality plywood and reinforced construction, we provide reliable product protection during storage, handling and transportation. We also offer custom plywood boxes in Gandhidham based on dimensions, weight and application requirements.",
  brochureLink:"/gurukrupa-brochure.pdf",
  images:[
    {
      big: product4Big1,
      small: product4Small1,
    },
    {
      big: product4Big2,
      small: product4Small2,
    },
    {
      big: product4Big3,
      small:product4Small3,
    },
    {
      big: product4Big4,
      small:product4Small4,
    },
     {
      big: product4Big5,
      small: product4Small5,
    },
  ],
  qualities:[
    {
      icon:pro2Q1,
      title: "ISPM-15 Heat Treated",
    },
    {
      icon: pro2Q2,
      title: "High Load Capacity",
    },
    {
      icon: pro2Q3,
      title: "Moisture Resistant",
    },
    {
      icon: pro2Q4,
      title: "Strong & Durable",
    },
    {
      icon: pro2Q5,
      title: "100% Ready for Export",
    },
    {
      icon: pro2Q6,
      title: "Custom Sizes Available",
    },
  ],
  featureImage:pro4FeatureImg,
  features:[
    {
      icon:pro1f1,
      title: "Durable Structural Design",
      desc: "Manufactured with reinforced plywood construction for maximum strength and protection.",
    },

    {
      icon: pro1f2,
      title: "Lightweight Packaging",
      desc: "Offers strong load-bearing performance with reduced packaging weight.",
    },

    {
      icon: pro1f3,
      title: "Export-Ready Standards",
      desc: "Suitable for domestic and international shipping applications.",
    },

    {
      icon: pro1f4,
      title: "Versatile Industrial Applications",
      desc: "Ideal for machinery, engineering products, electronics, and industrial equipment.",
    },
  ],
  industriesHeading:"Precision Packaging for Every Industrial Application in Gandhidham",
  ctaTitle:"Need a Custom Plywood Boxes Size or Design?",
  ctaDesc:"We provide custom plywood boxes in Gandhidham designed according to your product dimensions, weight and protection requirements. Get in touch with our team today!",
  faqsHeading:"Frequently Asked Questions About Plywood Boxes in Gandhidham",
  faqs:[
    {
        question:" What are plywood boxes used for?",
        answer:"Plywood boxes are commonly used for packing machinery, industrial equipment, engineering components, electronics and other products that require strong protection during storage and transportation."
    },
     {
        question:"Are your plywood boxes suitable for export packaging?",
        answer:"Yes. We can provide suitable heat-treated plywood packaging solutions for export applications where applicable international shipping requirements need to be met."
    },
     {
        question:"Can plywood boxes be customized?",
        answer:"Yes. We manufacture custom plywood boxes in Gandhidham according to product dimensions, weight, design specifications and protection requirements."
    },
     {
        question:"What materials are used in manufacturing plywood boxes?",
        answer:"Plywood sheets, timber supports and suitable reinforcement materials are used according to the required box design, load capacity and intended application."
    },
     {
        question:"Are lightweight plywood boxes available?",
        answer:"Yes. Plywood boxes can be designed to provide a balance between strength, protection and practical handling weight, depending on the product and transportation requirements."
    },
     {
        question:" Can plywood boxes be made for heavy machinery?",
        answer:"Yes. Heavy-duty plywood boxes can be reinforced and designed to safely accommodate machinery, industrial equipment and other high-weight products."
    },
     {
        question:"Do you provide plywood boxes in different sizes?",
        answer:"Yes. We can manufacture plywood boxes in different dimensions according to your product size and packaging requirements."
    },
     {
        question:" Can plywood boxes be used for international shipping?",
        answer:"Yes. Plywood boxes are suitable for many export and international shipping applications, with the appropriate treatment and construction based on the destination and packaging requirements."
    }
  ],
  cta2Title:"Reliable Plywood Boxes Manufacturing for Gandhidham Industries",
  cta2Desc:"We are here to provide the best plywood boxes in gandhidham tailored to your needs."
  },
{
  metaTitle:"Wooden Crates Manufacturer in Gandhidham | Gurukrupa Wood Pvt. Ltd.",
  metaDesc:"Gurukrupa Wood is a trusted wooden crates manufacturer in Gandhidham, offering strong, durable crates for industrial packaging, machinery and export needs.",
  slug:"wooden-crates-manufacturer-in-gandhidham",
  img:product5,
  title:"Wooden Crates",
  breadcrumbHeading:" Wooden Crates Manufacturer in Gandhidham",
  desc:"Durable wooden crates ideal for export and heavy-duty packaging solutions.",
  breadcrumbImg : product5Bg,
  introHeading:"Premium Wooden Crates from a Trusted Manufacturer in Gandhidham",
  introDesc:"Gurukrupa Wood Pvt. Ltd. is a trusted Wooden Crates Manufacturer in Gandhidham, producing strong crates for industrial equipment, machinery, engineering components and secure transportation. Using quality timber and reinforced construction, we provide reliable protection during storage and handling. We also offer custom wooden crates in Gandhidham based on product dimensions, weight and transportation requirements.",
  brochureLink:"/gurukrupa-brochure.pdf",
  images:[
    {
      big: product5Big1,
      small: product5Small1,
    },
    {
      big: product5Big2,
      small: product5Small2,
    },
    {
      big: product5Big3,
      small:product5Small3,
    },
    {
      big: product5Big4,
      small:product5Small4,
    },
     {
      big: product5Big5,
      small: product5Small5,
    },
  ],
  qualities:[
    {
      icon:pro2Q1,
      title: "ISPM-15 Heat Treated",
    },
    {
      icon: pro2Q2,
      title: "High Load Capacity",
    },
    {
      icon: pro2Q3,
      title: "Moisture Resistant",
    },
    {
      icon: pro2Q4,
      title: "Strong & Durable",
    },
    {
      icon: pro2Q5,
      title: "100% Ready for Export",
    },
    {
      icon: pro2Q6,
      title: "Custom Sizes Available",
    },
  ],
  featureImage:pro5FeatureImg,
  features:[
    {
      icon:pro1f1,
      title: "Durable Structural Design",
      desc: "Manufactured with reinforced plywood construction for maximum strength and protection.",
    },

    {
      icon: pro1f2,
      title: "Lightweight Packaging",
      desc: "Offers strong load-bearing performance with reduced packaging weight.",
    },

    {
      icon: pro1f3,
      title: "Export-Ready Standards",
      desc: "Suitable for domestic and international shipping applications.",
    },

    {
      icon: pro1f4,
      title: "Versatile Industrial Applications",
      desc: "Ideal for machinery, engineering products, electronics, and industrial equipment.",
    },
  ],
  industriesHeading:"Precision Packaging for Every Industrial Application in Gandhidham",
  ctaTitle:"Need a Custom Wooden Crates Size or Design?",
  ctaDesc:"We provide custom wooden crates in Gandhidham designed around your product dimensions, weight and protection requirements.",
  faqsHeading:"Frequently Asked Questions About Wooden Crates in Gandhidham",
  faqs:[
    {
        question:"What are wooden crates used for?",
        answer:"Wooden crates are commonly used to pack and protect machinery, industrial equipment, engineering components and other products during storage, handling and transportation."
    },
     {
        question:"Can wooden crates be customized?",
        answer:"Yes. We manufacture custom wooden crates in Gandhidham according to product dimensions, weight, handling requirements and specific packaging needs."
    },
     {
        question:"Are your wooden crates suitable for export packaging?",
        answer:"Yes. Heat-treated wooden crates can be provided for export applications where ISPM-15 requirements apply to wooden packaging materials."
    },
     {
        question:"What wood is used for manufacturing wooden crates?",
        answer:"We use suitable quality timber selected according to the required strength, durability, crate design and intended application."
    },
     {
        question:"Do you manufacture heavy-duty wooden crates?",
        answer:"Yes. We manufacture heavy-duty wooden crates with reinforced construction for machinery, industrial equipment and other products with higher weight or protection requirements."
    },
     {
        question:"Are open-type and closed-type wooden crates available?",
        answer:"Yes. Wooden crates can be manufactured in different configurations, including open or closed designs, depending on the product and level of protection required."
    },
     {
        question:"Can internal support and reinforcements be added?",
        answer:"Yes. Internal supports, bracing and additional reinforcement can be incorporated into the crate design to help keep products stable and protected during transportation."
    },
     {
        question:"Do you supply wooden crates across India and for export?",
        answer:"Yes. We can supply wooden crates for industrial, commercial and export requirements based on the required specifications, quantity and destination."
    }
  ],
  cta2Title:"Reliable Wooden Crates Manufacturing for Gandhidham Industries",
  cta2Desc:"We are here to provide the best wooden crates in gandhidham tailored to your needs."
  },
]

export const stats=[
    {
        number:13,
        suffix:"+",
        title:"Years of Experience"
    },
     {
        number:500,
        suffix:"+",
        title:"Happy Clients"
    },
     {
        number:1000,
        suffix:"+",
        title:"Projects fullfiled"
    },
     {
        number:100,
        suffix:"+",
        title:"Quality Assurance"
    }
]

export const industries=[
    {
        icon:industry1,
        title:"Manufacturing"
    },
    {
        icon:industry2,
        title:"Engineering"
    },
    {
        icon:industry3,
        title:"Chemical"
    },
    {
        icon:industry4,
        title:"Logistics"
    },
    {
        icon:industry5,
        title:"Exporters"
    },
    {
        icon:industry6,
        title:"Industrial Equipment"
    }
]

export const clients=[
    {
        image:client1
    },
    {
        image:client2
    },
    {
        image:client3
    },
    {
        image:client4
    },
    {
        image:client5
    },
     {
        image:client6
    },
     {
        image:client7
    },
     {
        image:client8
    },
     {
        image:client9
    },
     {
        image:client10
    },
     {
        image:client11
    }
]

export const missionVisionData=[
    {
        icon:visionIcon,
        title:"Our Vision",
        desc:"To become a leading and trusted name in the wooden packaging industry by delivering innovative, durable, and high-quality packaging solutions across industries."
    },
      {
        icon:missionIcon,
        title:"Our Mission",
        desc:"To provide reliable and cost-effective wooden packaging products through continuous improvement, advanced manufacturing practices, and customer-focused service."
    }
]

export const valuesData=[
    {
        img:value1,
        title:"Quality First"
    },
    {
        img:value2,
        title:"Customer Focus"
    },
    {
        img:value3,
        title:"Integrity"
    },
    {
        img:value4,
        title:"Teamwork"
    },
    {
        img:value5,
        title:"Sustainability"
    }
]

export const serviceIntro=[
    {
        icon:serviceIntro1,
        title:"Safe & Reliable"
    },
     {
        icon:serviceIntro2,
        title:"Customised Solutions"
    },
     {
        icon:serviceIntro3,
        title:"Export Ready"
    },
     {
        icon:serviceIntro4,
        title:"On-Time Delivery"
    }
]

export const services=[
    {
        img:service1,
        icon:serviceIcon1,
        title:"Container Lashing",
        desc:"Professional lashing solutions to secure cargo inside containers during transportation and export shipping."
    },
    {
        img:service2,
        icon:serviceIcon2,
        title:"Industrial Packaging",
        desc:"Strong and customized packaging solutions for machinery, equipment, and industrial goods to ensure maximum protection."
    },
    {
        img:service3,
        icon:serviceIcon3,
        title:"Export Packaging Support",
        desc:"Export-ready packaging with ISPM-15 treatment and compliance support for international shipments."
    },
    {
        img:service4,
        icon:serviceIcon4,
        title:"Custom Packaging",
        desc:"Expert consultation to understand your requirements and recommend the right packaging solution."
    },
    {
        img:service5,
        icon:serviceIcon5,
        title:"Packaging Design",
        desc:"Professional design support to develop packaging structures that ensure safety, strength, and cost-efficiency."
    },
    {
        img:service6,
        icon:serviceIcon6,
        title:"Bulk Packaging Supply",
        desc:"Large-scale packaging supply with consistent quality, timely delivery, and competitive pricing."
    }
]

export const customiseNeeds=[
    {
        icon:customiseIcon1,
        title:"Size & Dimension"
    },
     {
        icon:customiseIcon2,
        title:"Load Capacity"
    },
     {
        icon:customiseIcon3,
        title:"Wood Type"
    },
     {
        icon:customiseIcon4,
        title:"Internal Support"
    },
     {
        icon:customiseIcon5,
        title:"Design Structure"
    },
     {
        icon:customiseIcon6,
        title:"Finishing / Treatment"
    }
]

export const customiseProcess=[
    {
        number:"01",
        title:"Requirement Analysis"
    },
    {
        number:"02",
        title:"Custom Design & Planning"
    },
    {
        number:"03",
        title:"Material Selection"
    },
    {
        number:"04",
        title:"Precision Manufacturing"
    },
    {
        number:"05",
        title:"Quality Inspection"
    },
    {
        number:"06",
        title:"Packing & Delivery"
    }
]

export const featuredProductImages=[
    {
      big: product2Big1,
      small: product2Small1,
    },
    {
      big: product2Big2,
      small: product2Small2,
    },
    {
      big: product2Big3,
      small:product2Small3,
    },
    {
      big: product2Big4,
      small:product2Small4,
    },
     {
      big: product2Big5,
      small: product2Small5,
    },
]

export const featureProductFeatures=[
  {
      icon:pro2Q1,
      title: "ISPM-15 Heat Treated",
    },
    {
      icon: pro2Q2,
      title: "High Load Capacity",
    },
    {
      icon: pro2Q3,
      title: "Moisture Resistant",
    },
    {
      icon: pro2Q4,
      title: "Strong & Durable",
    },
    {
      icon: pro2Q5,
      title: "100% Ready for Export",
    },
    {
      icon: pro2Q6,
      title: "Custom Sizes Available",
    },
]

export const MundraProducts=[
{
  metaTitle:"Euro Pallets Manufacturer in Mundra | Gurukrupa Wood Pvt. Ltd.",
  metaDesc:"Looking for a Euro pallets manufacturer in Mundra? Get durable, export-ready Euro pallets designed for safe handling, storage and industrial transport.",
  slug:"euro-pallets-manufacturer-in-mundra",
  img:product1,
  title:"Euro Pallets",
  breadcrumbHeading:"Euro Pallets Manufacturer in Mundra",
  desc:"Durable export-grade euro pallets designed for safe storage and transportation.",
  breadcrumbImg : product1Bg,
  introHeading:"Premium Euro Pallets from a Trusted Manufacturer in Mundra",
  introDesc:"Our Euro pallets in Mundra are designed for efficient material handling and reliable performance across industrial supply chains. Made from quality timber with precise construction, they provide strong load support for safe storage, smooth transportation and secure export packaging. We offer durable Euro pallet solutions tailored to industrial, logistics and export requirements, helping businesses manage goods efficiently while maintaining dependable packaging standards.",
  brochureLink:"/gurukrupa-brochure.pdf",
  images:[
    {
      big: product1Big1,
      small: product1Small1,
    },
    {
      big: product1Big2,
      small: product1Small2,
    },
    {
      big: product1Big3,
      small:product1Small3,
    },
    {
      big: product1Big4,
      small:product1Small4,
    },
     {
      big: product1Big5,
      small: product1Small5,
    },
  ],
  qualities:[
    {
      icon:pro1Q1,
      title: "ISPM-15 Heat Treated",
    },
    {
      icon: pro1Q2,
      title: "High Load Capacity",
    },
    {
      icon: pro1Q3,
      title: "EPAL Standard Quality",
    },
    {
      icon: pro1Q4,
      title: "Strong & Durable",
    },
    {
      icon: pro1Q5,
      title: "Moisture Resistant",
    },
    {
      icon: pro1Q6,
      title: "100% Ready for Export",
    },
  ],
  featureImage:pro1FeatureImg,
  features:[
    {
      icon:pro1f1,
      title: "Premium Quality Wood",
      desc: "Made from high-quality, seasoned timber for maximum strength.",
    },

    {
      icon: pro1f2,
      title: "Heat Treated (ISPM-15)",
      desc: "Compliant with ISPM-15 standards for safe global shipping.",
    },

    {
      icon: pro1f3,
      title: "High Load Capacity",
      desc: "Designed to handle heavy loads with excellent stability and durability.",
    },

    {
      icon: pro1f4,
      title: "Cost Effective",
      desc: "Long-lasting and reusable pallets for better ROI.",
    },
  ],
  industriesHeading:"Precision Packaging for Every Industrial Application in Mundra",
  ctaTitle:"Need a Custom Euro Pallet Size or Design?",
  ctaDesc:"We provide Euro pallet solutions tailored to your load capacity, product dimensions and transportation requirements. Get in touch with our team to discuss your specific pallet needs.",
  faqsHeading:"Frequently Asked Questions About Euro Pallets in Mundra",
  faqs:[
    {
        question:"Are your Euro pallets ISPM-15 compliant?",
        answer:"Heat-treated Euro pallet options are available to meet applicable ISPM-15 requirements for international shipping."
    },
     {
        question:"What wood is used for Euro pallets?",
        answer:"Euro pallets are generally made using quality solid timber selected for strength, durability and reliable load support."
    },
     {
        question:"Can you provide custom sizes?",
        answer:"Yes, custom pallet sizes and specifications can be discussed based on your product dimensions and handling requirements."
    },
     {
        question:"What is the static load capacity of Euro pallets?",
        answer:"Static load capacity depends on pallet construction, timber quality and load distribution. Contact our team for product-specific capacity details."
    },
     {
        question:"Do you offer heat treatment?",
        answer:"Yes, heat-treatment options are available for pallets intended for export shipments requiring ISPM-15 compliance."
    },
     {
        question:"Can we get a sample before a bulk order?",
        answer:"Sample availability can be discussed with our team depending on the pallet design and order requirements."
    },
     {
        question:"What is the lead time for Euro pallet orders?",
        answer:"Lead time depends on pallet specifications, order quantity and production schedules. Contact us for an estimated delivery timeline."
    },
     {
        question:"Do you deliver across India and for export?",
        answer:"We can discuss supply and transportation arrangements for domestic and export-related requirements based on your order and destination."
    }
  ],
  cta2Title:"Reliable Euro Pallet Manufacturing for Mundra Industries",
  cta2Desc:"We are here to provide durable and export-ready Euro pallet solutions tailored to your industrial needs in Mundra."
  },
{
  metaTitle:"Wooden Pallets Manufacturer in Mundra | Gurukrupa Wood Pvt. Ltd.",
  metaDesc:"Choose a wooden pallets manufacturer in Mundra for strong, reliable pallets. Explore custom wooden pallets for industrial storage, shipping and logistics.",
  slug:"wooden-pallets-manufacturer-in-mundra",
  img:product2,
  title:"Wooden Pallets",
  breadcrumbHeading:"Wooden Pallets Manufacturer in Mundra",
  desc:"Strong and reliable wooden pallets for industrial handling and logistics applications.",
  breadcrumbImg : product2Bg,
  introHeading:"Premium Wooden Pallets from a Trusted Manufacturer in Mundra",
  introDesc:"Our wooden pallets are designed for repeated industrial use with reliable performance across storage and transportation operations. Manufactured using quality timber and sturdy construction, they provide stable load support, safe material handling and practical packaging solutions for businesses in Mundra.",
  brochureLink:"/gurukrupa-brochure.pdf",
  images:[
    {
      big: product2Big1,
      small: product2Small1,
    },
    {
      big: product2Big2,
      small: product2Small2,
    },
    {
      big: product2Big3,
      small:product2Small3,
    },
    {
      big: product2Big4,
      small:product2Small4,
    },
     {
      big: product2Big5,
      small: product2Small5,
    },
  ],
  qualities:[
    {
      icon:pro2Q1,
      title: "ISPM-15 Heat Treated",
    },
    {
      icon: pro2Q2,
      title: "High Load Capacity",
    },
    {
      icon: pro2Q3,
      title: "Moisture Resistant",
    },
    {
      icon: pro2Q4,
      title: "Strong & Durable",
    },
    {
      icon: pro2Q5,
      title: "100% Ready for Export",
    },
    {
      icon: pro2Q6,
      title: "Custom Sizes Available",
    },
  ],
  featureImage:pro2FeatureImg,
  features:[
    {
      icon:pro2f1,
      title: "Long Service Life",
      desc: "Designed for repeated industrial usage with reliable performance.",
    },

    {
      icon: pro2f2,
      title: "Safe Material Handling",
      desc: "Provides secure support during storage and transportation.",
    },

    {
      icon: pro2f3,
      title: "Heavy Duty Construction",
      desc: "Built using premium-quality wood for maximum strength and durability.",
    },

    {
      icon: pro2f4,
      title: "Cost Effective",
      desc: "Long-lasting and reusable pallets for better ROI.",
    },
  ],
  industriesHeading:"Precision Packaging for Every Industrial Application in Mundra",
  ctaTitle:"Need a Custom Wooden Pallet Size or Design?",
  ctaDesc:"We provide custom wooden pallet solutions based on your product dimensions, load requirements and handling needs. Get in touch with our team today!",
  faqsHeading:"Frequently Asked Questions About Wooden Pallets in Mundra",
  faqs:[
    {
        question:"What types of wooden pallets are available in Mundra?",
        answer:"Wooden pallets are available in different sizes, designs and load capacities to meet industrial storage, handling and transportation needs."
    },
     {
        question:"Can I order custom-sized wooden pallets in Mundra?",
        answer:"Yes, custom wooden pallets can be manufactured according to your product dimensions, weight and specific handling requirements."
    },
     {
        question:"Are wooden pallets suitable for export packaging?",
        answer:"Yes, wooden pallets treated according to ISPM-15 requirements can be used for international shipping where applicable."
    },
     {
        question:"What type of wood is used to manufacture wooden pallets?",
        answer:"Quality timber is commonly used to manufacture wooden pallets, offering strength, durability and reliable load support."
    },
     {
        question:"What is the load capacity of industrial wooden pallets?",
        answer:"Load capacity depends on pallet design, timber quality, dimensions and load distribution. Contact the manufacturer for specific load ratings."
    },
     {
        question:" Can wooden pallets be reused for multiple shipments?",
        answer:"Yes, durable wooden pallets can be reused when they remain structurally sound and are suitable for the intended load and handling conditions."
    },
     {
        question:"Which industries use wooden pallets in Mundra? ",
        answer:"Manufacturing, engineering, logistics, warehousing, export and industrial equipment businesses use wooden pallets for efficient material handling."
    },
     {
        question:"How can I get a quote for wooden pallets in Mundra?",
        answer:"Contact Gurukrupa Wood with your required pallet dimensions, quantity and load specifications to discuss pricing and suitable wooden pallet solutions."
    }
  ],
  cta2Title:"Reliable Wooden Pallet Manufacturing for Mundra Industries",
  cta2Desc:"We are here to provide strong and reliable wooden pallet solutions tailored to your industrial needs in Mundra."
  },
{
  metaTitle:"Wooden Boxes Manufacturer in Mundra | Gurukrupa Wood Pvt. Ltd.",
  metaDesc:"Get durable wooden boxes in Mundra for industrial packaging and shipping. Choose custom wooden box solutions designed for safe storage and transportation.",
  slug:"wooden-boxes-manufacturer-in-mundra",
  img:product3,
  title:"Wooden Boxes",
  breadcrumbHeading:"Wooden Boxes Manufacturer in Mundra",
  desc:"Secure Wooden Boxes built for industrial packaging and safe material handling.",
  breadcrumbImg : product3Bg,
  introHeading:"Premium Wooden Boxes from a Trusted Manufacturer in Mundra",
  introDesc:"Our wooden boxes are manufactured using quality timber and sturdy construction methods to provide reliable protection during storage, shipping and export operations. Designed for industrial packaging requirements, these boxes offer excellent strength, durability and load-bearing performance for businesses in Mundra.",
  brochureLink:"/gurukrupa-brochure.pdf",
  images:[
    {
      big: product3Big1,
      small: product3Small1,
    },
    {
      big: product3Big2,
      small: product3Small2,
    },
    {
      big: product3Big3,
      small:product3Small3,
    },
    {
      big: product3Big4,
      small:product3Small4,
    },
     {
      big: product3Big5,
      small: product3Small5,
    },
  ],
  qualities:[
    {
      icon:pro2Q1,
      title: "ISPM-15 Heat Treated",
    },
    {
      icon: pro2Q2,
      title: "High Load Capacity",
    },
    {
      icon: pro2Q3,
      title: "Moisture Resistant",
    },
    {
      icon: pro2Q4,
      title: "Strong & Durable",
    },
    {
      icon: pro2Q5,
      title: "100% Ready for Export",
    },
    {
      icon: pro2Q6,
      title: "Custom Sizes Available",
    },
  ],
  featureImage:pro3FeatureImg,
  features:[
    {
      icon:pro1f1,
      title: "Premium Quality Wood",
      desc: "Made from high-quality, seasoned timber for maximum strength.",
    },

    {
      icon: pro1f2,
      title: "Heat Treated (ISPM-15)",
      desc: "Compliant with ISPM-15 standards for safe global shipping.",
    },

    {
      icon: pro1f3,
      title: "Heavy Duty Construction",
      desc: "Built using premium-quality wood for maximum strength and durability.",
    },

    {
      icon: pro1f4,
      title: "Cost Effective",
      desc: "Durable wooden boxes that provide protection and long-term value for industrial packaging.",
    },
  ],
  industriesHeading:"Precision Packaging for Every Industrial Application in Mundra",
  ctaTitle:"Need a Custom Wooden Box Size or Design?",
  ctaDesc:"We provide customised wooden boxes designed around your product dimensions, weight and transportation requirements. Get in touch with our team today!",
  faqsHeading:"Frequently Asked Questions About Wooden Boxes in Mundra",
  faqs:[
    {
        question:"Do you provide customized wooden boxes in Mundra?",
        answer:"Yes, we offer customised wooden box solutions based on product dimensions, weight, packaging requirements and transportation needs."
    },
     {
        question:"Are your wooden boxes suitable for export packaging?",
        answer:"Yes, wooden boxes can be manufactured with suitable specifications and heat treatment where required for export shipments."
    },
     {
        question:" What types of products can be packed in wooden boxes?",
        answer:"Wooden boxes can be used for packaging machinery, industrial components, equipment, tools and other goods requiring protective packaging."
    },
     {
        question:"Do you offer heavy-duty wooden boxes?",
        answer:"Yes, heavy-duty wooden box designs can be made for industrial goods and products requiring additional structural support."
    },
     {
        question:"What wood is used for manufacturing wooden boxes?",
        answer:"Quality timber is commonly used to manufacture wooden boxes, offering strength, durability and dependable protection."
    },
     {
        question:"Can wooden boxes be made according to specific product dimensions?",
        answer:"Yes, custom dimensions and designs can be discussed to ensure a suitable fit for your products and shipping requirements."
    },
     {
        question:"Are wooden boxes reusable for multiple shipments?",
        answer:"Yes, sturdy wooden boxes can be reused when they remain in good condition and are suitable for the intended products and handling conditions."
    },
     {
        question:"How can I get a quote for wooden boxes in Mundra?",
        answer:"Contact Gurukrupa Wood with your required box dimensions, quantity and application details to discuss pricing and suitable packaging options."
    }
  ],
  cta2Title:"Reliable Wooden Box Manufacturing for Mundra Industries",
  cta2Desc:"We are here to provide strong and reliable wooden box packaging solutions tailored to your industrial needs in Mundra."
  },
{
  metaTitle:"Plywood Boxes Manufacturer in Mundra | Gurukrupa Wood Pvt. Ltd.",
  metaDesc:"Find a plywood boxes manufacturer in Mundra for lightweight, sturdy packaging. Get custom plywood boxes for secure industrial shipping and export applications.",
  slug:"plywood-boxes-manufacturer-in-mundra",
  img:product4,
  title:"Plywood Boxes",
  breadcrumbHeading:"Plywood Boxes Manufacturer in Mundra",
  desc:"High strength plywood boxes ideal for export and heavy-duty packaging solutions.",
  breadcrumbImg : product4Bg,
  introHeading:"Premium Plywood Boxes from a Trusted Manufacturer in Mundra",
  introDesc:"Our plywood boxes are designed to provide reliable protection during storage, handling and transportation. Manufactured with quality plywood sheets and sturdy framing, they offer a practical balance of strength and reduced packaging weight. These boxes are suitable for industrial equipment, engineering components and export cargo requiring dependable packaging solutions in Mundra.",
  brochureLink:"/gurukrupa-brochure.pdf",
  images:[
    {
      big: product4Big1,
      small: product4Small1,
    },
    {
      big: product4Big2,
      small: product4Small2,
    },
    {
      big: product4Big3,
      small:product4Small3,
    },
    {
      big: product4Big4,
      small:product4Small4,
    },
     {
      big: product4Big5,
      small: product4Small5,
    },
  ],
  qualities:[
    {
      icon:pro2Q1,
      title: "ISPM-15 Heat Treated",
    },
    {
      icon: pro2Q2,
      title: "High Load Capacity",
    },
    {
      icon: pro2Q3,
      title: "Moisture Resistant",
    },
    {
      icon: pro2Q4,
      title: "Strong & Durable",
    },
    {
      icon: pro2Q5,
      title: "100% Ready for Export",
    },
    {
      icon: pro2Q6,
      title: "Custom Sizes Available",
    },
  ],
  featureImage:pro4FeatureImg,
  features:[
    {
      icon:pro1f1,
      title: "Durable Structural Design",
      desc: "Manufactured with reinforced plywood construction for maximum strength and protection.",
    },

    {
      icon: pro1f2,
      title: "Lightweight Packaging",
      desc: "Offers strong load-bearing performance with reduced packaging weight.",
    },

    {
      icon: pro1f3,
      title: "Export-Ready Standards",
      desc: "Suitable for domestic and international shipping applications.",
    },

    {
      icon: pro1f4,
      title: "Versatile Industrial Applications",
      desc: "Ideal for machinery, engineering products, electronics, and industrial equipment.",
    },
  ],
  industriesHeading:"Precision Packaging for Every Industrial Application in Mundra",
  ctaTitle:"Need a Custom Plywood Box Size or Design?",
  ctaDesc:"We provide tailor-made plywood boxes based on your product dimensions, weight and transportation requirements.",
  faqsHeading:"Frequently Asked Questions About Plywood Boxes in Mundra",
  faqs:[
    {
        question:"What are plywood boxes used for?",
        answer:"Plywood boxes are used for packaging machinery, industrial components, electronics and other goods that require secure storage and transportation."
    },
     {
        question:"Are your plywood boxes suitable for export packaging?",
        answer:"Yes, plywood boxes can be suitable for export packaging. Additional solid-wood components may require applicable ISPM-15 treatment depending on the packaging design and destination requirements."
    },
     {
        question:"Can plywood boxes be customized?",
        answer:"Yes, custom plywood boxes can be manufactured according to product dimensions, weight, handling needs and transportation requirements."
    },
     {
        question:"What materials are used in manufacturing plywood boxes?",
        answer:"Plywood sheets, timber framing and suitable fasteners are commonly used to manufacture strong and reliable plywood packaging boxes."
    },
     {
        question:"Are lightweight plywood boxes available?",
        answer:"Yes, lightweight plywood box designs can be considered for products that need reliable protection while keeping packaging weight manageable."
    },
     {
        question:"Can internal partitions and supports be added?",
        answer:"Yes, internal partitions, wooden supports and protective fittings can be incorporated to help secure products during transportation."
    },
     {
        question:"Do you handle bulk manufacturing orders?",
        answer:"Bulk plywood box orders can be discussed based on the required dimensions, design, quantity and production schedule."
    },
     {
        question:"Do you deliver across India and support export requirements?",
        answer:"Supply and transportation arrangements can be discussed for domestic orders and export packaging requirements based on the destination and order specifications."
    }
  ],
  cta2Title:"Reliable Plywood Box Manufacturing for Mundra Industries",
  cta2Desc:"We are here to provide strong, lightweight and customised plywood packaging solutions tailored to your industrial needs in Mundra."
  },
{
  metaTitle:"Wooden Crates Manufacturer in Mundra | Gurukrupa Wood Pvt. Ltd.",
  metaDesc:"Looking for a wooden crates manufacturer in Mundra? Get heavy-duty wooden crates for safe handling, industrial packaging and reliable goods transportation.",
  slug:"wooden-crates-manufacturer-in-mundra",
  img:product5,
  title:"Wooden Crates",
  breadcrumbHeading:"Wooden Crates Manufacturer in Mundra",
  desc:"Durable wooden crates ideal for export and heavy-duty packaging solutions.",
  breadcrumbImg : product5Bg,
  introHeading:"Heavy-Duty Wooden Crates from a Trusted Manufacturer in Mundra",
  introDesc:"Our heavy-duty wooden crates are designed for demanding industrial packaging and transportation requirements. Manufactured using quality timber and sturdy construction, they provide reliable support for machinery, equipment and bulky products. These wooden crates offer practical protection for businesses in Mundra looking for secure packaging solutions for storage and shipping.",
  brochureLink:"/gurukrupa-brochure.pdf",
  images:[
    {
      big: product5Big1,
      small: product5Small1,
    },
    {
      big: product5Big2,
      small: product5Small2,
    },
    {
      big: product5Big3,
      small:product5Small3,
    },
    {
      big: product5Big4,
      small:product5Small4,
    },
     {
      big: product5Big5,
      small: product5Small5,
    },
  ],
  qualities:[
    {
      icon:pro2Q1,
      title: "ISPM-15 Heat Treated",
    },
    {
      icon: pro2Q2,
      title: "High Load Capacity",
    },
    {
      icon: pro2Q3,
      title: "Moisture Resistant",
    },
    {
      icon: pro2Q4,
      title: "Strong & Durable",
    },
    {
      icon: pro2Q5,
      title: "100% Ready for Export",
    },
    {
      icon: pro2Q6,
      title: "Custom Sizes Available",
    },
  ],
  featureImage:pro5FeatureImg,
  features:[
    {
      icon:pro1f1,
      title: "Durable Structural Design",
      desc: "Manufactured with reinforced plywood construction for maximum strength and protection.",
    },

    {
      icon: pro1f2,
      title: "Lightweight Packaging",
      desc: "Offers strong load-bearing performance with reduced packaging weight.",
    },

    {
      icon: pro1f3,
      title: "Export-Ready Standards",
      desc: "Suitable for domestic and international shipping applications.",
    },

    {
      icon: pro1f4,
      title: "Versatile Industrial Applications",
      desc: "Ideal for machinery, engineering products, electronics, and industrial equipment.",
    },
  ],
  industriesHeading:"Precision Packaging for Every Industrial Application in Mundra",
  ctaTitle:"Need a Custom Wooden Crate Size or Design?",
  ctaDesc:"We provide customised wooden crate solutions based on your product dimensions, weight and transportation requirements.",
  faqsHeading:"Frequently Asked Questions About Wooden Crates in Mundra",
  faqs:[
    {
        question:"What are wooden crates used for?",
        answer:"Wooden crates are used for packaging and transporting machinery, industrial equipment, engineering components and bulky goods that require structural protection."
    },
     {
        question:"Can wooden crates be customized?",
        answer:"Yes, custom wooden crates can be designed according to product dimensions, load requirements and specific handling needs."
    },
     {
        question:"Are your wooden crates suitable for export packaging?",
        answer:"Yes, wooden crates can be manufactured for export packaging. Applicable ISPM-15 treatment may be required for solid-wood components depending on the shipment destination."
    },
     {
        question:"What wood is used for manufacturing wooden crates?",
        answer:"Quality timber is commonly used to manufacture wooden crates, providing strength, durability and dependable structural support."
    },
     {
        question:"Do you manufacture heavy-duty wooden crates?",
        answer:"Yes, heavy-duty crate designs can be discussed for machinery, industrial equipment and other goods requiring additional structural support."
    },
     {
        question:"Are open-type and closed-type crates available?",
        answer:"Open-type and closed-type wooden crate designs can be considered based on product dimensions, ventilation needs and transportation requirements."
    },
     {
        question:"Can internal support and reinforcements be added?",
        answer:"Yes, internal supports, reinforced framing and protective fittings can be incorporated to help secure heavy or delicate products during transit."
    },
     {
        question:"Do you supply wooden crates across India and for export?",
        answer:"Supply and transportation arrangements can be discussed for domestic orders and export packaging requirements based on order specifications and destination."
    }
  ],
  cta2Title:"Reliable Wooden Crate Manufacturing for Mundra Industries",
  cta2Desc:"We are here to provide strong and reliable wooden crate solutions tailored to your industrial packaging needs in Mundra."
  },
]

export const additionalProductMundra = [
  {
    slug:"customised-packaging-solution-in-mundra",
    img:product6,
    title:"Customised Packaging",
    desc:"Tailor made wooden packaging solutions to match your export requirments.",
    faqHeading:"Frequently Asked Questions About Customised Packaging in Mundra",
    faqs:[
      {
        question:"What are customised wooden packaging solutions?",
        answer:"Customised wooden packaging solutions are boxes, pallets and crates designed according to specific product dimensions, weight and transportation requirements."
      },
      {
        question:"Can you manufacture wooden packaging in custom sizes?",
        answer:"Yes, custom wooden packaging can be designed according to your product measurements and packaging specifications."
      },
      {
        question:"What types of customised packaging do you offer?",
        answer:"Custom packaging options can include wooden boxes, plywood boxes, wooden pallets and wooden crates, depending on your requirements."
      },
      {
        question:"Can customised wooden packaging support heavy products?",
        answer:"Yes, reinforced packaging designs can be developed according to product weight, load distribution and handling conditions."
      },
      {
        question:"Which materials are used for customised wooden packaging?",
        answer:"Timber and plywood are commonly used, with material selection depending on the packaging design and intended application."
      },
      {
        question:"Do you provide customised packaging for export?",
        answer:"Yes, export packaging solutions can be designed to meet applicable shipping and destination requirements, including relevant wood treatment regulations."
      },
      {
        question:"What information is needed for a custom packaging quote?",
        answer:"Product dimensions, weight, quantity, packaging type, material preferences and transportation requirements help determine a suitable quotation."
      },
      {
        question:"How can I request customised wooden packaging in Mundra?",
        answer:"Contact Gurukrupa Wood with your product specifications and packaging requirements to discuss suitable designs and request a quote."
      }
    ]
  }
]

export const utubePoints=[
    {
        icon:advancedManufacturing,
        title:"Advanced Manufacturing",
        desc:"Modern processes for precision and consistent quality."
    },
    {
        icon:qualityAssured,
        title:"Quality Assured",
        desc:"Strict quality checks for durable, reliable packaging."
    },
    {
        icon:customSolutions,
        title:"Custom Solutions",
        desc:"Tailor-made packaging to meet your specific needs."
    },
    {
        icon:timelyDelivery,
        title:"Timely Delivery",
        desc:"Reliable delivery, right on schedule."
    }
]